import './pie_chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.SentimentPieChartView extends Monitoring.Views.Charts.PieChartView

  initialize: (@options = {}) ->
    @title = I18n.t('monitoring.dashboard.charts.sentiment')
    @title_en = I18n.t('monitoring.dashboard.charts.sentiment', {'locale': 'en'})
    super(@options)
    @name = 'sentiment'

  getNewQuery: (event) ->
    name = event.point.code || event.point.name
    query = @searchQuery.deepCopy()
    query.set('sentiment', [ name ])
    return query

  getPieData: (name) ->
    return [
      ['negative', @getCount(name, 'negative')],
      ['neutral', @getCount(name, 'neutral')],
      ['positive', @getCount(name, 'positive')],
    ]

  getCount: (facet_name, term_name) ->
    facet = @facets[facet_name][term_name]
    return facet if facet # this works in surveys module
    facet = _.find(@facets[facet_name]['terms'], (facet) ->
      facet.term == term_name
    )
    return if facet then facet.count else 0 # this works in monitoring mode

  benchmarkChartOptions: (currentBenchmark) ->
    series = @_getOptions().series

    benchmark_series = $.extend({}, series[0])
    benchmark_series.data = $.extend([], @_benchmarkDataFromResponse())

    sorted_benchmark_data = []
    for group in series[0].data
      indexOfGroup = _.findIndex(benchmark_series.data, {code: group.name})
      if indexOfGroup > -1
        benchmark_series.data[indexOfGroup].name = benchmark_series.data[indexOfGroup].code
        sorted_benchmark_data.push(benchmark_series.data[indexOfGroup])
      else
        sorted_benchmark_data.push({code: group.name, y: 0})
    benchmark_series.data = sorted_benchmark_data

    options = $.extend(true, @_getOptions(), @_getChartOptions())
    options.series = [benchmark_series]
    options.title = {text: currentBenchmark, y: 30, align: 'left', x:10, floating: true}
    options.title.style = {fontSize: '13px', fontWeight: 'bold'}
    options.chart.renderTo = @$el.find('.benchmark-chart')[0]

    return options

  _benchmarkDataFromResponse: () ->
    _.filter(@dataBenchmark.benchmark_data[0].data, (benchmarkData) -> benchmarkData.code != 'missing')
